import { POI_DISPLAY_TYPE } from '@/enums/poi';
import type { ManagedPoiContent, PoiContent } from '@/services/dto';

type PoiImageDisplayType = typeof POI_DISPLAY_TYPE.DETAIL_IMAGE | typeof POI_DISPLAY_TYPE.LIST_IMAGE;

const getLocalizedContent = (
    content: ManagedPoiContent['content'] | undefined,
    language: string
): string => content?.[language] || content?.['ko'] || '';

export const getManagedImageUrl = (
    managedContents: ManagedPoiContent[] | undefined,
    language: string,
    primaryType: PoiImageDisplayType,
    fallbackType: PoiImageDisplayType
): string => {
    const primaryItem = managedContents?.find((item) => item.display_type === primaryType);
    const primaryUrl = getLocalizedContent(primaryItem?.content, language);
    if (primaryUrl) {
        return primaryUrl;
    }

    const fallbackItem = managedContents?.find((item) => item.display_type === fallbackType);
    return getLocalizedContent(fallbackItem?.content, language);
};

/** Ảnh lớn trong popup detail: DETAIL_IMAGE → LIST_IMAGE */
export const getPoiDetailImageUrl = (managedContents: ManagedPoiContent[] | undefined, language: string) =>
    getManagedImageUrl(managedContents, language, POI_DISPLAY_TYPE.DETAIL_IMAGE, POI_DISPLAY_TYPE.LIST_IMAGE);

/** Ảnh thumbnail list/carousel: LIST_IMAGE → DETAIL_IMAGE */
export const getPoiListImageUrl = (managedContents: ManagedPoiContent[] | undefined, language: string) =>
    getManagedImageUrl(managedContents, language, POI_DISPLAY_TYPE.LIST_IMAGE, POI_DISPLAY_TYPE.DETAIL_IMAGE);

const getShopTrademarkImageUrl = (poi: PoiContent, language: string) =>
    poi.contents?.shopTmrkImgUrlApp?.[language] || poi.contents?.shopTmrkImgUrlApp?.['ko'] || '';

export const getPoiDetailImageUrlFromContent = (poi: PoiContent, language: string) => {
    const fromManaged = getPoiDetailImageUrl(poi.managedContents, language);
    return fromManaged || getShopTrademarkImageUrl(poi, language);
};

export const getPoiListImageUrlFromContent = (poi: PoiContent, language: string) => {
    const fromManaged = getPoiListImageUrl(poi.managedContents, language);
    return fromManaged || getShopTrademarkImageUrl(poi, language);
};
